<template>
  <EditForm :organization="organization"/>
</template>

<script>
import EditForm from '@/pages/admin/organization/EditForm'
import OrganizationService from '@/services/OrganizationService'

export default {
  components: {EditForm},
  data: () => ({
    organization: OrganizationService.getDefaultItem()
  }),
  computed: {}
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/organization/Add.vue